var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChatboxEllipses = function SvgChatboxEllipses(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 3H4.875C4.17942 3.00198 3.51289 3.27918 3.02103 3.77103C2.52918 4.26289 2.25198 4.92942 2.25 5.625V14.625C2.25198 15.3206 2.52918 15.9871 3.02103 16.479C3.51289 16.9708 4.17942 17.248 4.875 17.25H6.75V21L11.1431 17.3372C11.2106 17.2808 11.2957 17.25 11.3836 17.25H19.125C19.8206 17.248 20.4871 16.9708 20.979 16.479C21.4708 15.9871 21.748 15.3206 21.75 14.625V5.625C21.748 4.92942 21.4708 4.26289 20.979 3.77103C20.4871 3.27918 19.8206 3.00198 19.125 3Z",
    stroke: "#3776AB",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96875 10.125C8.96875 10.9362 8.31117 11.5938 7.5 11.5938C6.68883 11.5938 6.03125 10.9362 6.03125 10.125C6.03125 9.31383 6.68883 8.65625 7.5 8.65625C8.31117 8.65625 8.96875 9.31383 8.96875 10.125Z",
    fill: "#3776AB",
    stroke: "#3776AB",
    strokeWidth: 0.0625
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4688 10.125C13.4688 10.9362 12.8112 11.5938 12 11.5938C11.1888 11.5938 10.5312 10.9362 10.5312 10.125C10.5312 9.31383 11.1888 8.65625 12 8.65625C12.8112 8.65625 13.4688 9.31383 13.4688 10.125Z",
    fill: "#3776AB",
    stroke: "#3776AB",
    strokeWidth: 0.0625
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9688 10.125C17.9688 10.9362 17.3112 11.5938 16.5 11.5938C15.6888 11.5938 15.0312 10.9362 15.0312 10.125C15.0312 9.31383 15.6888 8.65625 16.5 8.65625C17.3112 8.65625 17.9688 9.31383 17.9688 10.125Z",
    fill: "#3776AB",
    stroke: "#3776AB",
    strokeWidth: 0.0625
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatboxEllipses, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chatbox-ellipses.2ae20006.svg";
export { ForwardRef as ReactComponent };